import { createContext } from 'react';

export type FileLoaderOptions = {
  withCredentials: boolean;
};

export const FileLoaderOptionsContext = createContext<FileLoaderOptions>({
  withCredentials: false,
});
